/* eslint-disable no-nested-ternary */
import React from "react";
import styled from "styled-components";

import { Flex } from "../../../../components/Flex";
import { TextWithTruncated } from "../../../../components/TextWithTruncated";
import { PermissionInvite } from "../../../../model/permissions/PermisisonInvite";
import { PermissionInviteStatus } from "../../../../model/permissions/types/PermissionInviteStatus";
import { Rounded } from "../../../../theme/Rounded";
import { Spacing } from "../../../../theme/Spacing";
import { PendingMemberCREATED } from "./PendingMemberCREATED";
import { PendingMemberPENDING } from "./PendingMemberPENDING";
import { PendingMemberREJECTED } from "./PendingMemberREJECTED";
import { AtiraIcon } from "../../../../components/AtiraIcon";
import { faCopy } from "@fortawesome/free-regular-svg-icons/faCopy";
import { AtiraToast } from "../../../../utils/AtiraToast";
import { useTranslation } from "react-i18next";
import { getInviteLink } from "../../utils/permissionUtils";
import { TeamRoleBadge } from "../TeamRoleBadge";
import { Button } from "../../../../components/Button";

const PendingMemberWrapper = styled(Flex)`
  border-radius: ${Rounded.md};
  background-color: ${({ theme }) => theme.sub};
  justify-content: space-between;
  align-items: center;
  padding: ${Spacing.s};
  gap: ${Spacing.m};
`;

const StyledButton = styled(Button)`
  margin: 0;
  padding: ${Spacing.s};
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${Spacing.s};
  color: ${({ theme }) => theme.white};
`;

interface PendingMemberProps {
  invite: PermissionInvite;
}

export const PendingMember: React.FC<PendingMemberProps> = ({ invite }) => {
  const { t } = useTranslation();

  const onCopy = () => {
    navigator.clipboard.writeText(getInviteLink(invite));
    AtiraToast.success(t("common.copy.success"));
  };

  return (
    <PendingMemberWrapper>
      <Flex width="100%" justifyContent="space-between" alignItems="center">
        <Flex alignItems="center" gap="s">
          <TextWithTruncated>{invite.inviteeEmail}</TextWithTruncated>
          {invite.orgRole ? <TeamRoleBadge role={invite.orgRole} /> : null}
        </Flex>

        <StyledButton backgroundColor="main" onClick={onCopy}>
          <AtiraIcon icon={faCopy} />
          {t("common.copyInviteLink")}
        </StyledButton>
      </Flex>

      {invite.status === PermissionInviteStatus.CREATED ? (
        <PendingMemberCREATED invite={invite} />
      ) : invite.status === PermissionInviteStatus.REJECTED ? (
        <PendingMemberREJECTED />
      ) : invite.status === PermissionInviteStatus.PENDING ? (
        <PendingMemberPENDING invite={invite} />
      ) : null}
    </PendingMemberWrapper>
  );
};
